// Stale-time tiers for TanStack Query (A2 spike protection — see plan U4).
//
// Lives in a leaf module (no imports) so any file can reference the tiers at
// module scope. They used to be exported from `main.tsx`, which sits at the
// top of the import graph: a module-level `staleTime: STALE_TIME_SLOW` in any
// transitive import of `App` hit the TDZ (`main` was still evaluating) and
// took the whole app down silently.
//
//   - DAILY (30s): weight_log, daily_log, workout_log — change at human
//     timescales; UX wants fresh values on tab switch.
//   - SLOW (10min): profile, daily_targets, speediance config/mapping,
//     exercise_weights — change session-to-session or week-to-week.
export const STALE_TIME_DAILY = 30 * 1000;
export const STALE_TIME_SLOW = 10 * 60 * 1000;
